/*eslint-disable*/
import React from 'react';
import * as Styled from '../styles';

export const RadioGroup = ({ children, value, onChange, name }) => {
  return (
    <Styled.RadioGroupContainer role="radiogroup">
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          name,
          isSelected: value === child.props.value,
          onChange,
        }),
      )}
    </Styled.RadioGroupContainer>
  );
};
